import { Button, Flex, Heading, HStack, Tooltip } from "@chakra-ui/react";
import { FunctionComponent, ReactElement, useMemo } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { themeColors } from "../../../styles/theme";

interface NavItemProps {
	label: string;
	icon: ReactElement;
	path: string;
	sidebarOpen: boolean;
	firstElement?: boolean;
}

/**
 * Handles displaying individual Navigation items in the Sidebar
 */
const NavItem: FunctionComponent<NavItemProps> = (props: NavItemProps): ReactElement => {
	// Props
	const { label, icon, path, sidebarOpen, firstElement } = props;
	const location = useLocation();

	const isInnerActiveTab = () => {
		const { pathname } = location;
		// Ignore the /attorney url prefix and remove any beginning forward slash
		const mainNavPath = path.replace("/attorney", "").slice(1).split("/")[0];
		const mainCurrentPath = pathname.replace("/attorney", "").slice(1).split("/")[0];
		const isActive =
			mainCurrentPath !== "" && mainNavPath !== "" && mainNavPath.indexOf(mainCurrentPath) !== -1 ? true : false;
		return isActive;
	};

	return (
		<Tooltip hasArrow label={label} bg="gray.200" w="100%" color="black" isDisabled={sidebarOpen}>
			<Button marginTop={firstElement ? "20px" : "0px"} bg="none" p={0} w="100%" borderRadius="0px">
				<NavLink
					to={path}
					style={({ isActive }) => ({
						color: isActive || isInnerActiveTab() ? themeColors.orange[500] : themeColors.gray[700],
						width: "100%",
						padding: "10px 15px"
					})}>
					<HStack fontSize={"30px"} alignItems={"flex-end"}>
						{icon}
						{sidebarOpen && (
							<Flex justifyContent={"space-between"} alignItems={"center"}>
								<Heading as="h4" fontSize="20px" fontWeight="500" pb="1px">
									{label}
								</Heading>
							</Flex>
						)}
					</HStack>
				</NavLink>
			</Button>
		</Tooltip>
	);
};

export default NavItem;
